import { Box } from '@mui/material';
import PrimarySearchAppBar from "../components/PrimarySearchAppBar";
import JsonTable from '../components/ProfileDataTable';
import { useAuth0 } from "@auth0/auth0-react";
import { useAppMetadata } from "../auth0/Auth0MetaData";

export const ProfilePage = () => {
	const auth0Obj = useAuth0();
	const { user } = auth0Obj;
	const appMetadata = useAppMetadata();
	const isAuthenticated = auth0Obj.isAuthenticated;

	function getUserJSON() {
		let rv = null;
		if (user) {
			rv = user;
			if (appMetadata) {
				rv.appMetadata = appMetadata;
			}
		}
		return rv;
	};

	const userJson = getUserJSON();
	return (
		<Box>
			<PrimarySearchAppBar />
			{!isAuthenticated && (
				<Box>
					A tartalom megtekintéséhez be kell jelentkeznie.
					You are not authenticated. Log in to see the contents.
				</Box>
			)}
			{isAuthenticated && !appMetadata &&(
				<Box>
					Error: no appMetadata for this authenticated user!
				</Box>
			)}
			{isAuthenticated && appMetadata && (
				<Box display={"flex"} flexDirection={"column"} height={"80vh"} gap={"24px"} padding={"16px"}>
					{/* <TextareaAutosize
						value={JSON.stringify(getUserJSON(), null, 2)}
					/> */}
					<Box>
						<h1>Profil adatok</h1>
						<JsonTable jsonData={userJson} />
					</Box>
				</Box>
			)}
		</Box>
	);
};
